/* loaded by smart-asset */
export default require("./32~dxrvVFgI.svg")